import { useNavigate } from "react-router-dom";
import snacksBanner from "../../assets/images/snacks-banner.png";

export default function SnacksBannerSection() {
  const navigate = useNavigate();

  const handleVisitStore = () => {
    navigate("/store");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="wrapper">
      <section id="snacks-banner-section">
        <img src={snacksBanner} alt="Snacks Banner" className="snacks-banner-image" />

        <div className="snacks-banner-content">
          <h2>SNACKS WORTH STOCKING UP ON</h2>

          <p>Curabitur suscipit, nisl sit amet porta bibendum, leo lacus semper libero fringilla imperdiet ante enim id eros.</p>

          <button onClick={handleVisitStore}>VISIT STORE</button>
        </div>
      </section>
    </div>
  );
}
